import { Box, Button, Card, Image, Text } from '@zillow/constellation-10';
import { styled } from '@/styled-system/jsx';

const FacebookAdPreviewCard = styled(Card, {
  base: {
    padding: '0 !important',
    overflow: 'hidden',
    minWidth: '300px',
    '& img': {
      maxWidth: '300px',
      minWidth: '300px',
      maxHeight: '300px',
      minHeight: '300px',
      objectFit: 'cover',
    },
  },
});

const LearnMoreButton = styled(Button, {
  base: {
    '&, &:focus, &:active, &:hover, & span': {
      backgroundColor: '#e4e6eb !important',
      color: 'black !important',
      border: 'none !important',
      boxShadow: 'none !important',
    },
  },
});

const EllipsisText = styled(Text, {
  base: {
    maxWidth: '140px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

export const FacebookAdPreview = ({
  imageUrl,
  address,
  title,
}: {
  imageUrl: string;
  address: string;
  title: string;
}) => (
  <FacebookAdPreviewCard elevated={false} className="facebook-preview">
    <Image src={imageUrl} />
    <Box style={{ display: 'flex', justifyContent: 'space-between', padding: '20px 16px' }}>
      <Box css={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <EllipsisText textStyle="body-bold">{title}</EllipsisText>
        <EllipsisText textStyle="body-xs" css={{ color: 'gray.400' }}>
          {address}
        </EllipsisText>
      </Box>
      <LearnMoreButton>Learn More</LearnMoreButton>
    </Box>
  </FacebookAdPreviewCard>
);
